import {
  Button,
  Card,
  Col,
  Descriptions,
  Modal,
  QRCode,
  Row,
  Space,
  Table,
  Typography,
  Upload,
} from "antd";
import React, { useImperativeHandle, useEffect, useState, useRef } from "react";
import { logoFullWhite, logoIconWhite } from "assets/images/logo/";
import { CallSVG, CaptivePortalSVG, LocationSVG, MailWhiteSVG } from "assets";
import dayjs from "dayjs";
import {
  doiTuongOptions,
  gioiTinhOptions,
} from "assets/constants/select-catagory-options";
import { normalizePhoneNumber } from "helper/common";
import "./SignSecure.scss";
import Icons from "assets/icons";
import { medicalExaminationService } from "api";
import { HeaderPrintForm, Notification } from "components/common";
import ReactToPrint from "react-to-print";
import SignatureCanvas from "react-signature-canvas";
import { FORMAT_TIME } from "types/enums";
import moment from "moment";
import SignPdfView from "./SignPdfView/SignPdfView";
import NewSignSecure from "./NewSignSecure";
import SearchPatientService from "api/searchPatient";

const SignSecure = (props) => {
  const { modalRef } = props;
  const sigCanvas = useRef<any>({});
  const hoTenCanvas = useRef<any>({});
  const bvCanvas = useRef<any>({});
  const sigBvCanvas = useRef<any>({});
  const [signatureHotenImage, setSignatureHotenImage] = useState(null);
  const [signatureImage, setSignatureImage] = useState(null);
  const [bvImage, setBvImage] = useState(null);
  const [signatureBvImage, setSignatureBvImage] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [data, setData] = useState<any>(null);
  const [thongTinBN, setThongTinBN] = useState<any>(null);
  const printRef = useRef<any>();
  const NewPrintRef = useRef();
  const modalViewer = useRef<any>();
  const [filePdf, setFilePdf] = useState<File | string | object>({});
  useImperativeHandle(modalRef, () => ({
    openModal: () => {
      openModal();
    },
    closeModal: () => {
      closeModal();
    },
    setData: setData,
    setThongTinBN: setThongTinBN,
  }));
  useEffect(() => {});
  useEffect(() => {}, [isModalOpen]);
  const openModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };
  const onPrint = async () => {
    window.print();
  };
  const getThanNhan = (hoTen, quanHe) => {
    if (hoTen) {
      return quanHe ? hoTen + `(${quanHe})` : hoTen;
    }
    return "";
  };
  //fetch
  const fetchPhieuKhamIn = async (params) => {
    try {
      let response = await SearchPatientService.getPKInById(params);
      setThongTinBN(response.data);
    } catch (err) {}
  };
  useEffect(() => {
    if (data && data.id) {
      fetchPhieuKhamIn({ id: data.id });
    }
  }, [data]);
  useEffect(() => {}, [thongTinBN]);

  const onClearSign = () => {
    sigCanvas.current.clear();
    hoTenCanvas.current.clear();
    bvCanvas.current.clear();
    sigBvCanvas.current.clear();
  };

  const onSaveSign = () => {
    if (sigCanvas.current.isEmpty()) {
      // alert('Please provide a signature first.');
      return;
    }

    const signatureHotenDataURL = hoTenCanvas.current.toDataURL();
    const signatureDataURL = sigCanvas.current.toDataURL();
    const bvDataURL = bvCanvas.current.toDataURL();
    const signatureBvDataURL = sigBvCanvas.current.toDataURL();

    setSignatureHotenImage(signatureHotenDataURL);
    setSignatureImage(signatureDataURL);
    setBvImage(bvDataURL);
    setSignatureBvImage(signatureBvDataURL);
  };

  const customRequest = async (options: any) => {
    // const file_size = options.file.size;
    // try {
    //   if (file_size <= 3000000) {
    //     const formData = new FormData();
    //     formData.append("pdfFiles", options.file as Blob);
    //     Notification("success", "Đã tải file thành công");
    //   } else {
    //     Notification("warning", "Kích thước file vượt quá giới hạn (3MB)");
    //   }
    // } catch (error) {
    //   Notification(
    //     "error",
    //     "Lỗi khi tải file hoặc kích cỡ file đạt quá giới hạn"
    //   );
    // }
    // return false;
  };

  const handleOnView = () => {
    try {
      modalViewer.current?.openModal();
      // const url = `/qlkhambenh/chi-dinh-cdha/show-file-ket-qua?ids=${record.id}`;
      // const res = await axiosClient.get(url, { responseType: "blob" });
      // const data = res.data;
      // setFilePdf(data);
    } catch (error) {
      Notification("error", "Đã xảy ra lỗi khi xem tệp");
    }
  };

  const handleOnUpload = () => {};

  const getTodayString = () => {
    // const today = moment().format();
    const day = moment().format("DD");
    const month = moment().format("MM");
    const year = moment().format("YYYY");
    const time = moment().format("HH:mm");
    return `${time} Ngày ${day} tháng ${month} năm ${year}`;
  };

  return (
    <Row className="modal">
      <Modal
        wrapClassName="modal-custom"
        centered
        open={isModalOpen}
        onCancel={closeModal}
        closable={false}
        footer={null}
        width={960}
      >
        <div className="print-sign">
          <Row ref={printRef}>
            <HeaderPrintForm />
            <Row
              style={{
                paddingLeft: "20px",
                // paddingTop: "30px",
                paddingRight: "20px",
              }}
            >
              <Row>
                <Typography.Title
                  style={{
                    fontWeight: "700",
                    fontSize: "20px",
                  }}
                >
                  PHIẾU ĐỒNG Ý CUNG CẤP THÔNG TIN
                </Typography.Title>
              </Row>
              <Row>
                <Col span={12}>
                  <Row>
                    <Descriptions
                      column={{
                        xs: 1,
                        sm: 1,
                        md: 1,
                        xl: 1,
                        lg: 1,
                        xxl: 1,
                      }}
                      size="small"
                    >
                      <Descriptions.Item
                        label="Họ và tên"
                        labelStyle={{ width: "94px" }}
                        contentStyle={{
                          fontWeight: "600",
                        }}
                      >
                        {thongTinBN?.hoTen}
                      </Descriptions.Item>
                      <Descriptions.Item
                        label="Ngày sinh"
                        labelStyle={{ width: "94px" }}
                        contentStyle={{
                          fontWeight: "600",
                        }}
                      >
                        {thongTinBN?.ngaySinh
                          ? dayjs(thongTinBN?.ngaySinh).format("DD/MM/YYYY")
                          : ""}
                      </Descriptions.Item>
                      <Descriptions.Item
                        label="Tuổi"
                        labelStyle={{ width: "94px" }}
                        contentStyle={{
                          fontWeight: "600",
                        }}
                      >
                        {thongTinBN?.tuoi}
                      </Descriptions.Item>
                      <Descriptions.Item
                        label="Giới tinh"
                        labelStyle={{ width: "94px" }}
                        contentStyle={{
                          fontWeight: "600",
                        }}
                      >
                        {gioiTinhOptions.find(
                          (it) => it.value === thongTinBN?.gioiTinh
                        )?.label || ""}
                      </Descriptions.Item>
                      <Descriptions.Item
                        label="Điện thoại"
                        labelStyle={{ width: "94px" }}
                        contentStyle={{
                          fontWeight: "600",
                        }}
                      >
                        {thongTinBN?.dienThoai}
                      </Descriptions.Item>
                      <Descriptions.Item
                        label="Địa chỉ"
                        labelStyle={{ width: "94px" }}
                        contentStyle={{
                          fontWeight: "600",
                        }}
                      >
                        {thongTinBN?.diaChiTongHop}
                      </Descriptions.Item>
                      <Descriptions.Item
                        label="Nhân thân"
                        labelStyle={{ width: "94px" }}
                        contentStyle={{
                          fontWeight: "600",
                        }}
                      >
                        {getThanNhan(
                          thongTinBN?.hoTenThanNhan,
                          thongTinBN?.quanHeThanNhan
                        )}
                      </Descriptions.Item>
                      <Descriptions.Item
                        label="Lý do khám"
                        labelStyle={{ width: "94px" }}
                        contentStyle={{
                          fontWeight: "600",
                        }}
                      >
                        {thongTinBN?.lyDoKham}
                      </Descriptions.Item>
                    </Descriptions>
                  </Row>
                </Col>
                <Col span={12}>
                  <Descriptions
                    column={{
                      xs: 1,
                      sm: 1,
                      md: 1,
                      xl: 1,
                      lg: 1,
                      xxl: 1,
                    }}
                  >
                    <Descriptions.Item
                      label="Khám lúc"
                      labelStyle={{ width: "124px" }}
                      contentStyle={{
                        fontWeight: "600",
                      }}
                    >
                      {thongTinBN?.ngayTao
                        ? dayjs(thongTinBN?.ngayTao).format(
                            "HH:mm A - DD/MM/YYYY"
                          )
                        : null}
                    </Descriptions.Item>
                    <Descriptions.Item
                      label="Mã phiếu khám"
                      labelStyle={{ width: "124px" }}
                      contentStyle={{
                        fontWeight: "600",
                      }}
                    >
                      {thongTinBN?.id}
                    </Descriptions.Item>
                    <Descriptions.Item
                      label="Mã bệnh nhân"
                      labelStyle={{ width: "124px" }}
                      contentStyle={{
                        fontWeight: "600",
                      }}
                    >
                      {thongTinBN?.maBenhNhan}
                    </Descriptions.Item>
                    <Descriptions.Item
                      label="Đối tượng KCB"
                      labelStyle={{ width: "124px" }}
                      contentStyle={{
                        fontWeight: "600",
                      }}
                    >
                      {doiTuongOptions.find(
                        (it) => it.value === thongTinBN?.doiTuong
                      )?.label || ""}
                    </Descriptions.Item>
                  </Descriptions>
                  <Row>
                    <QRCode
                      size={120}
                      value={`${thongTinBN?.id} - ${thongTinBN?.maBenhNhan}`}
                    />
                  </Row>
                </Col>
              </Row>
              <Row style={{ marginTop: "10px" }}>
                <Card
                  size="small"
                  title="Nội dung thoả thuận"
                  style={{ width: "860px" }}
                  bodyStyle={{
                    height: "auto",
                  }}
                >
                  <div>
                    &nbsp; &nbsp;Văn bản này để thông báo và đạt được sự đồng ý
                    của khách hàng về việc xử lý dữ liệu cá nhân của khách hàng
                    cho mục đích tiến hành cung cấp dịch vụ điều trị cho khách
                    hàng của Bệnh Viện Chuyên Khoa Mắt Alina trực thuộc Công ty
                    TNHH Doanh Nghiệp Xã Hội Bệnh Viện Chuyên Khoa Mắt Alina –
                    đơn vị thành viên của Alina Vision Pte Ltd (trụ sở chính tại
                    Singapore) <b>(“Bệnh viện/Chúng tôi”)</b>.
                  </div>
                  <div>
                    &nbsp; &nbsp;Khách hàng có quyền lựa chọn cho phép Bệnh viện
                    thu thập và xử lý dữ liệu của bạn, một phần hoặc toàn bộ
                    và/hoặc với điều kiện kèm theo. Việc thu thập và xử lý dữ
                    liệu cá nhân của bạn không phải là yêu cầu theo luật định
                    hay hợp đồng. Tuy nhiên, như đã nêu ở trên, Bệnh viện sẽ
                    không thể cung cấp cho khách hàng dịch vụ khám, chữa bệnh
                    và/hoặc điều trị bệnh mà không có dữ liệu cần thiết cho các
                    mục đích dịch vụ đó.
                  </div>
                  <div>
                    &nbsp; &nbsp;Tôi, người ký tên dưới đây với tư cách là khách
                    hàng/bệnh nhân, <b>{thongTinBN?.hoTen.toUpperCase()}</b> có
                    mã số <b>{thongTinBN?.maBenhNhan}</b> (“
                    <b>Khách hàng</b>”) đăng ký sử dụng các dịch vụ tại Bệnh
                    viện. Bằng việc ký vào văn bản này, tôi xác nhận rằng đã đọc
                    kỹ, hiểu rõ, đồng ý để Bệnh Viện thu thập, lưu trữ, phân
                    tích, sử dụng, chuyển giao, chia sẻ và thực hiện các hoạt
                    động xử lý dữ liệu cá nhân và bệnh án của tôi (“
                    <b>Xử lý Dữ liệu</b>)” theo các nội dung, điều kiện, quy
                    định được giải thích tại văn bản này.
                  </div>
                  <div>
                    <b>1. Dữ liệu được xử lý</b> (Thông tin Khách hàng/Dữ liệu
                    cá nhân)
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "20px" }}>a)</div>
                    <div style={{ paddingLeft: "20px" }}>
                      Là các thông tin, dữ liệu cá nhân được sử dụng để nhận
                      dạng và xác định Khách hàng bao gồm nhưng không giới hạn
                      những thông tin cơ bản như họ tên, ngày tháng năm sinh,
                      nhóm máu, giới tính, nơi sinh, nơi thường trú, nơi ở hiện
                      tại, địa chỉ liên hệ, địa chỉ thư điện tử, hình ảnh, quốc
                      tịch, số điện thoại, nghề nghiệp, chứng minh thư nhân dân
                      hoặc thẻ căn cước công dân, thông tin bảo hiểm, thông tin
                      giao dịch, lịch sử truy cập, hồ sơ bệnh án/sức khoẻ và các
                      dữ liệu cá nhân cơ bản khác.
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "20px" }}>b)</div>
                    <div style={{ paddingLeft: "20px" }}>
                      Các dữ liệu và thông tin cá nhân nhạy cảm về tình trạng
                      sức khỏe bao gồm cả các thông tin y tế như các triệu chứng
                      lâm sàng chính, xét nghiệm, lịch sử khám bệnh, các chẩn
                      đoán và cách điều trị.
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "20px" }}>c)</div>
                    <div style={{ paddingLeft: "20px" }}>
                      Các dữ liệu cá nhân về di truyền, sinh trắc học, tình
                      trạng giới tính, đời sống, tài chính.
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "20px" }}>d)</div>
                    <div style={{ paddingLeft: "20px" }}>
                      Các dữ liệu cá nhân cơ bản và nhạy cảm khác mà Bệnh Viện
                      nhận thấy là cần phải thu thập, xử lý trong quá trình điều
                      trị, cung cấp dịch vụ cho Khách hàng.
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "20px" }}>e)</div>
                    <div style={{ paddingLeft: "20px" }}>
                      [điền thêm thông tin về loại dữ liệu khác (nếu có)]
                    </div>
                  </div>
                  <div>
                    <b>2. Mục Đích Sử dụng</b>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "20px" }}>a)</div>
                    <div style={{ paddingLeft: "20px" }}>
                      Phục vụ việc đăng ký điều trị và điều trị cho Khách hàng.
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "20px" }}>b)</div>
                    <div style={{ paddingLeft: "20px" }}>
                      Liên hệ, hỗ trợ, hướng dẫn, cung cấp thông tin cho Khách
                      hàng trong và sau khi điều trị; nhận và trả lời các phản
                      hồi, yêu cầu của Khách hàng.
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "20px" }}>c)</div>
                    <div style={{ paddingLeft: "20px" }}>
                      Để trao đổi, cung cấp thông tin, báo cáo và làm việc với
                      các cơ quan nhà nước, các đơn vị chuyên môn, các nhà tài
                      trợ, các nhà cung cấp dịch vụ, các đơn vị bảo hiểm và/hoặc
                      các cơ quan, đơn vị liên quan khác.
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "20px" }}>d)</div>
                    <div style={{ paddingLeft: "20px" }}>
                      Phục vụ việc cung cấp dịch vụ (các dịch vụ được Bệnh Viện
                      cung cấp trực tiếp tại cơ sở khám chữa bệnh của Bệnh Viện
                      hoặc dịch vụ khác do Bệnh Viện cung cấp “Dịch Vụ”) và xử
                      lý các hoạt động phát sinh hoặc liên quan đến việc cung
                      cấp dịch vụ như xác nhận các giao dịch và thực hiện các
                      khoản thanh toán.
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "20px" }}>e)</div>
                    <div style={{ paddingLeft: "20px" }}>
                      Phục vụ các hoạt động kiểm tra, kiểm soát, tuân thủ, thống
                      kê...và các hoạt động quản lý nội bộ cần thiết nhằm đảm
                      bảo, nâng cao chất lượng chuẩn đoán, chăm sóc, điều trị
                      người bệnh.
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "20px" }}>f)</div>
                    <div style={{ paddingLeft: "20px" }}>
                      Tuân thủ nghĩa vụ pháp lý: Chúng tôi có nghĩa vụ pháp lý
                      để thu thập, sử dụng hoặc lưu trữ Thông Tin Khách Hàng của
                      quý khách trong một số trường hợp nhất định, bao gồm khi
                      được yêu cầu, được tư vấn, đề nghị hoặc đòi hỏi bởi các cố
                      vấn pháp lý hoặc bất kỳ quy định pháp luật, văn bản dưới
                      luật, văn bản hoặc yêu cầu của chính phủ hay các cơ quan
                      có thẩm quyền tại địa phương hoặc nước ngoài, yêu cầu của
                      cơ quan nhà nước có thẩm quyền bao gồm nhưng không giới
                      hạn nghĩa vụ công bố thông tin, báo cáo theo quy định pháp
                      luật về khuyến mại, lưu trữ hồ sơ, kiểm toán, điều tra và
                      giải quyết khiếu nại hoặc tranh chấp, tuân thủ các lệnh
                      của tòa án hoặc các yêu cầu pháp lý, văn bản hoặc yêu cầu
                      của chính phủ hoặc quy định khác; hoặc các thỏa thuận
                      khác; và bảo vệ quyền hoặc tài sản của chúng tôi trong
                      trường hợp khiếu nại hoặc tranh chấp, thực hiện các nghĩa
                      vụ trong các giao dịch, hợp đồng.
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "20px" }}>g)</div>
                    <div style={{ paddingLeft: "20px" }}>
                      Phục vụ các hoạt động nghiên cứu, phân tích... do Bệnh
                      Viện tổ chức hoặc tham gia.
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "20px" }}>h)</div>
                    <div style={{ paddingLeft: "20px" }}>
                      Phục vụ các hoạt động quảng bá, tiếp thị của Bệnh Viện
                      hoặc của Bên thứ ba liên quan.
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "20px" }}>i)</div>
                    <div style={{ paddingLeft: "20px" }}>
                      Phục vụ hoạt động tuyển dụng, đào tạo nhân viên, thực tập
                      sinh.
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "20px" }}>j)</div>
                    <div style={{ paddingLeft: "20px" }}>
                      Phục vụ các hoạt động vận hành, quản lý của Bệnh Viện bao
                      gồm nhưng không giới hạn ở hoạt động gây quỹ, nhân đạo, tổ
                      chức sự kiện, hội thảo, hội nghị.
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "20px" }}>k)</div>
                    <div style={{ paddingLeft: "20px" }}>
                      {" "}
                      Nhằm ngăn chặn, phát hiện và phòng chống gian lận và lạm
                      dụng, rủi ro tài sản và tín dụng nhằm bảo vệ an ninh của
                      Khách Hàng, Bệnh Viện và của những người khác.
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "20px" }}>l)</div>
                    <div style={{ paddingLeft: "20px" }}>
                      {" "}
                      Cho một số mục đích cụ thể khác phục vụ cho hoạt động của
                      Bệnh Viện phù hợp với quy định pháp luật.
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "20px" }}>m)</div>
                    <div style={{ paddingLeft: "20px" }}>
                      [điền thêm thông tin về mục đích khác (nếu có)]
                    </div>{" "}
                  </div>
                  <div>
                    <b>3. Cách Thức Thu Thập</b>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "20px" }}>a)</div>
                    <div style={{ paddingLeft: "20px" }}>
                      Bệnh Viện thu thập các thông tin do Khách hàng (i) cung
                      cấp trong quá trình đăng ký hoặc sử dụng dịch vụ y tế;
                      (ii) tương tác với các kênh thông tin mạng của Bệnh Viện
                      (iii) thực hiện đăng ký nhận tin, tham gia thành viên (iv)
                      tham gia hội thảo, sự kiện, điều tra, khảo sát do Bệnh
                      Viện tổ chức hoặc tham gia.
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "20px" }}>b)</div>
                    <div style={{ paddingLeft: "20px" }}>
                      Chúng tôi tự động thu thập một số loại thông tin khi Khách
                      hang sử dụng Dịch Vụ hoặc thực hiện tương tác trong quá
                      trình sử dụng Dịch vụ bao gồm nhưng không giới hạn ở các
                      trang mà Khách hàng ghé thăm từ trang website; Youtube,
                      Facebook...của Bệnh Viện.
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "20px" }}>c)</div>
                    <div style={{ paddingLeft: "20px" }}>
                      Thu thập và sử dụng cookies: Chúng tôi sử dụng cookie và
                      các công nghệ tương tự khác (gọi chung là “cookie”) để
                      nhận diện trình duyệt hoặc thiết bị của quý khách, tìm
                      hiểu thêm về sở thích của quý khách, cung cấp cho quý
                      khách các tính năng và dịch vụ thiết yếu. Khi một Khách
                      hàng truy cập hoặc sử dụng trang web của Bệnh Viên, thông
                      tin cá nhân có thể được thu thập tự động thông qua cookies
                      bao gồm: địa chỉ IP và/hoặc tên miền; hệ điều hành (loại
                      trình duyệt và nền tảng); ngày, thời gian và thời lượng
                      truy cập vào trang website.
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "20px" }}>d)</div>
                    <div style={{ paddingLeft: "20px" }}>
                      Thông tin từ các nguồn khác bao gồm từ các nhà cung cấp
                      dịch vụ, đối tác và các nguồn công khai có sẵn.
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "20px" }}>e)</div>
                    <div style={{ paddingLeft: "20px" }}>
                      [điền thêm thông tin về mục đích khác (nếu có)]
                    </div>{" "}
                  </div>
                  <div>
                    <b>4. Cách Thức Bảo Vệ</b>
                  </div>
                  <div>
                    <div style={{ width: "20px" }}>a)</div>
                    <div style={{ paddingLeft: "20px" }}>
                      Bệnh Viện áp dụng các biện pháp quản lý, kỹ thuật, vật lý
                      nhằm đảm bảo tính bảo mật, toàn vẹn cho thông tin của
                      Khách hàng.
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "20px" }}>b)</div>
                    <div style={{ paddingLeft: "20px" }}>
                      Khi thu thập thông tin, Bệnh Viện sẽ nỗ lực tối đa trong
                      phạm vi cho phép để thực hiện việc lưu giữ và bảo mật
                      Thông Tin Khách Hàng tại hệ thống máy chủ. Thông Tin Khách
                      Hàng được bảo mật bằng tường lửa và phần mềm chống vi-rút
                      để đảm bảo, trong phạm vi có thể, rằng nó không bị các bên
                      trái phép truy cập. Trang website của Bệnh Viện có các
                      biện pháp bảo mật (mã hóa lớp cổng bảo mật tối thiểu
                      128-bit) đư ợc thiết kế để bảo vệ chống mất mát, sử dụng
                      sai và/hoặc thay đổi, sao chép, xoá Thông Tin Khách Hàng
                      dưới sự kiểm soát của Bệnh Viện. Các thông tin trên các
                      trang website Bệnh Viện được bảo vệ bằng chứng chỉ SSL
                      128-bit.
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "20px" }}>c)</div>
                    <div style={{ paddingLeft: "20px" }}>
                      Chúng tôi lưu trữ hồ sơ bệnh nhân trong hệ thống Hồ Sở Y
                      Tế Điện Tử của chúng tôi.
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "20px" }}>d)</div>
                    <div style={{ paddingLeft: "20px" }}>
                      {" "}
                      Đối với Bệnh án giấy, Bệnh Viện sẽ bảo quản tại tại kho
                      HSBA có khóa và chỉ có nhân viên có thẩm quyền mới có thể
                      truy cập.
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "20px" }}>e)</div>
                    <div style={{ paddingLeft: "20px" }}>
                      <b>Bản sao điện tử:</b> Chúng tôi sẽ lưu trữ trên hệ thống
                      (Nhà cung cấp dịch vụ: HealthGraph Pvt. Ltd) với trung tâm
                      dữ liệu / máy chủ Amazon Web Services (AWS) đặt tại
                      Singapore, bản sao dự phòng của hồ sơ y tế được lưu trữ
                      tại cơ sở hạ tầng của Amazon Web Service (AWS). Các máy
                      chủ theo tiêu chuẩn HIPAA và cơ sở dữ liệu được bảo vệ bởi
                      các biện pháp bảo vệ đảm bảo an ninh và chính sách kiểm
                      soát truy cập nghiêm ngặt. Dữ liệu này sẽ được mã hóa và
                      nhà cung cấp dịch vụ sẽ chỉ lưu trữ dữ liệu. Bản ghi sẽ
                      được lưu giữ theo quy định của pháp luật. Trong trường hợp
                      thay đổi nhà cung cấp dịch vụ, toàn bộ dữ liệu sẽ được
                      bệnh viện lưu giữ và chuyển vào hệ thống nhà cung cấp dịch
                      vụ mới với chính sách bảo mật và an toàn của tổ chức đó.
                      Toàn bộ dữ liệu sẽ bị xóa khỏi nhà cung cấp dịch vụ trước
                      đó.
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "20px" }}>f)</div>
                    <div style={{ paddingLeft: "20px" }}>
                      Các Bên thứ ba nhận, sử dụng Thông Tin Khách Hàng sẽ phải
                      tuân thủ nghiêm ngặt các nguyên tắc bảo mật thông tin của
                      Bệnh Viện, thực hiện đúng các quy định trong Chính Sách
                      Quyền Riêng Tư, các chính sách tương tự khác của Bệnh Viện
                      và các quy định pháp luật có liên quan. Bệnh Viện sẽ áp
                      dụng các biện pháp để yêu cầu nhân viên, nhà thầu và nhà
                      cung cấp dịch vụ hoặc bất kỳ bên thứ ba nào tôn trọng và
                      bảo vệ tính bảo mật của thông tin thu thập;
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "20px" }}>g)</div>
                    <div style={{ paddingLeft: "20px" }}>
                      Khách hàng có trách nhiệm đảm bảo những thông tin được
                      cung cấp là đầy đủ, chính xác và cập nhật nhất nhằm bảo vệ
                      quyền lợi của Khách hàng trong suốt quá trình sử dụng dịch
                      vụ. Bệnh Viện không chịu trách nhiệm trong trường hợp
                      Khách hàng cung cấp thông tin không đầy đủ và không chính
                      xác. Khách hàng tuyệt đối không sử dụng các công cụ,
                      chương trình hay các biện pháp để can thiệp trái phép vào
                      hệ thống làm thay đổi, sai lệch, sao chép, phát tán thông
                      tin.
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "20px" }}>h)</div>
                    <div style={{ paddingLeft: "20px" }}>
                      Thông Tin Khách Hàng bao gồm cả thông tin cá nhân cơ bản
                      và thông tin cá nhân nhạy cảm sẽ được lưu trữ, truy cập
                      hoặc chuyển giao đến nhiều quốc gia, bao gồm cả Việt Nam.
                      Khách hàng đã được giải thích rõ ràng, đã hiểu và đồng ý
                      toàn bộ với việc chuyển giao này. Thông Tin Khách Hàng
                      được chuyển giao sẽ được đảm bảo tuân thủ theo đúng quy
                      định pháp luật của Việt Nam, quy định pháp luật của nước
                      sở tại đồng thời phải tuân thủ nguyên tắc bảo mật riêng
                      của Bệnh Viện.
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "20px" }}>i)</div>
                    <div style={{ paddingLeft: "20px" }}>
                      Bệnh Viện sẽ lưu trữ Thông Tin Khách Hàng trong thời hạn
                      cần thiết hoặc trong thời hạn theo quy định của pháp luật
                      để thực hiện các dịch vụ, hoạt động như đã thông báo tại
                      Thoả Thuận này. Khi Thông Tin Khách Hàng không còn cần
                      thiết hoặc Bệnh Viện đã hoàn thành mục đích thu thập hoặc
                      khi quy định pháp luật yêu cầu, Chúng tôi sẽ thực hiện các
                      bước để ngừng lưu trữ; xoá, huỷ hoặc chấm dứt việc sử dụng
                      thông tin.
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "20px" }}>n)</div>
                    <div style={{ paddingLeft: "20px" }}>
                      [điền thêm thông tin về phương pháp khác (nếu có)]
                    </div>
                  </div>
                  <div>
                    <b>5. Cách Thức Chia Sẻ Thông Tin</b>
                  </div>
                  <div>
                    Dữ liệu cá nhân của Khách hàng thu thập được sẽ được Bệnh
                    Viện xử lý và có thể chia sẻ cho các bên liên quan (nếu có)
                    trong phạm vi quy định của pháp luật. Các bên liên quan nhận
                    Dữ liệu cá nhân của Khách hàng theo đúng Chính Sách Quyền
                    Riêng Tư và tuân thủ đầy đủ các quy định trong Chính Sách
                    Quyền Riêng Tư, các chính sách tương tự khác của Bệnh Viện
                    và các quy định pháp luật. Cụ thể:
                  </div>
                  <div>
                    <div style={{ width: "20px" }}>a)</div>
                    <div style={{ paddingLeft: "20px" }}>
                      Thực hiện theo quy định pháp luật và/hoặc yêu cầu của cơ
                      quan quản lý nhà nước có thẩm quyền của Việt Nam và/hoặc
                      của nước ngoài;
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "20px" }}>b)</div>
                    <div style={{ paddingLeft: "20px" }}>
                      Trong quá trình hoạt động, Bệnh Viện phải sử dụng, hợp tác
                      và giao dịch với các Bên thứ ba liên quan mà Thông Tin
                      Khách hàng có thể được chia sẻ để hỗ trợ các hoạt động và
                      chức năng của Bệnh Viện bao gồm các nhà cung cấp dịch vụ,
                      nhà thầu và đối tác (đơn vị cung cấp dịch vụ công nghệ
                      thông tin, các công ty cung cấp hỗ trợ tiếp thị, bán hàng,
                      tổ chức sự kiện, đào tạo, ngân hàng, công ty thẻ tín dụng,
                      cơ quan tuyển dụng, cố vấn chuyên nghiệp, chuyên gia chăm
                      sóc sức khỏe, công ty bảo hiểm...Trong trường hợp cần
                      thiết, các Bên thứ ba này có quyền truy cập vào Thông Tin
                      Khách Hàng để thực hiện các chức năng, công việc của họ.
                      Các Bên thứ ba này sẽ được yêu cầu phải tuân thủ đầy đủ
                      Chính sách Quyền Riêng Tư của Bệnh Viện và thực hiện việc
                      bảo mật thông tin thông qua các thỏa thuận, cam kết giữa
                      họ với chúng tôi.
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "20px" }}>c)</div>
                    <div style={{ paddingLeft: "20px" }}>
                      Thông Tin Khách Hàng có thể được chia sẻ cho những người
                      trực tiếp điều trị người bệnh, hoặc cho một số đối tượng
                      khai thác hồ sơ như người hành nghề trong các cơ sở khám
                      chữa bênh, nghiên cứu viên, thực tập viên đọc tại chỗ hoặc
                      sao chép để thực hiện nhiệm vụ được giao hoặc phục vụ công
                      tác nghiên cứu, đào tạo hoặc công tác chuyên môn kỹ thuật.
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "20px" }}>d)</div>
                    <div style={{ paddingLeft: "20px" }}>
                      Trong quá trình phát triển, Bệnh Viện hoặc chủ đầu tư, cổ
                      đông của Bệnh Viện có thể tham gia các hoạt động mua bán,
                      sáp nhập, tái cấu trúc, chuyển nhượng doanh nghiệp hoặc
                      các hình thức đầu tư, phát triển phù hợp với quy định pháp
                      luật. Trong các trường hợp như vậy, Thông Tin Khách Hàng
                      và quyền sử dụng sẽ được chuyển giao sang cho nhà đầu tư
                      mới. Nhà đầu tư mới có trách nhiệm tuân thủ các nguyên
                      tắc, chính sách, quy định về bảo vệ quyền riêng tư được
                      quy định tại Thoả Thuận này.
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "20px" }}>e)</div>
                    <div style={{ paddingLeft: "20px" }}>
                      [điền thêm thông tin về phương pháp khác (nếu có)]
                    </div>
                  </div>
                  <div>
                    <b>
                      6. Khả năng không mong muốn có thể xảy ra với Dữ liệu cá
                      nhân trong quá trình xử lý
                    </b>
                  </div>
                  <div>
                    Tuy nhiên, mặc dù Bệnh viên luôn cố gắng hết sức, các biện
                    pháp bảo mật không thể đảm bảo tuyệt đối trước tất cả các
                    mối đe dọa. Nếu Khách hàng tin rằng tính bảo mật của dữ liệu
                    của Khách hàng đã bị xâm phạm hoặc nếu Khách hàng muốn biết
                    thêm thông tin về các biện pháp chúng tôi sử dụng để bảo vệ
                    dữ liệu của bạn, vui lòng liên hệ với chúng tôi theo hướng
                    dẫn trong phần “9. Liên hệ với chúng tôi” bên dưới đây.
                  </div>
                  <div>
                    <b>7. Thời gian xử lý dữ liệu</b>
                  </div>
                  <div>
                    Dữ liệu của Khách hàng sẽ được bắt đầu xử lý từ ngày xác
                    nhận tại phần cuối của văn bản này và kết thúc khi mục đích
                    xử lý dữ liệu hoàn thành, hoặc một thời hạn khác mà pháp
                    luật cho phép.
                  </div>
                  <div>
                    <b>8. Quyền Của Khách Hàng</b>
                  </div>
                  <div>
                    Trừ trường hợp pháp luật có quy định khác, Khách hàng hoặc
                    đại diện của mình, có quyền thực hiện các quyền đối với dữ
                    liệu cá nhân của mình như sau:
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "20px" }}>a)</div>
                    <div style={{ paddingLeft: "20px" }}>
                      {" "}
                      Khách hàng luôn có thể chọn không cung cấp dữ liệu của
                      mình cho Bệnh viện, mặc dù chúng tôi có thể cần những dữ
                      liệu đó để xử lý yêu cầu của Khách hàng, trong trường hợp
                      đó, chúng tôi sẽ thông báo cho Khách hàng về những hạn chế
                      của chúng tôi trong việc cung cấp dịch vụ.
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "20px" }}>b)</div>
                    <div style={{ paddingLeft: "20px" }}>
                      Trong phạm vi mà Khách hàng đã đồng ý để chúng tôi xử lý
                      dữ liệu của bạn, Khách hàng có thể chọn ngừng vào bất kỳ
                      lúc nào;
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "20px" }}>c)</div>
                    <div style={{ paddingLeft: "20px" }}>
                      {" "}
                      Khách hàng có thể chọn thêm hoặc cập nhật dữ liệu mà bạn
                      đã cung cấp cho chúng tôi;
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "20px" }}>d)</div>
                    <div style={{ paddingLeft: "20px" }}>
                      Khách hàng có thể chọn xóa dữ liệu của mình hoặc có thể
                      chọn hạn chế việc chúng tôi xử lý dữ liệu của Khách hàng;
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "20px" }}>e)</div>
                    <div style={{ paddingLeft: "20px" }}>
                      Khách hàng có thể chọn phản đối việc chúng tôi xử lý dữ
                      liệu của Khách hàng;
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "20px" }}>f)</div>
                    <div style={{ paddingLeft: "20px" }}>
                      Khách hàng có thể chọn yêu cầu xem, chỉnh sửa hoặc yêu cầu
                      chúng tôi chỉnh sửa dữ liệu cá nhân của mình;
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "20px" }}>g)</div>
                    <div style={{ paddingLeft: "20px" }}>
                      Khách hàng có thể chọn rút lại sự đồng ý đối với việc xử
                      lý dữ liệu của mình. Trong trường hợp này, sự rút lại
                      không ảnh hưởng đến giá trị pháp lý của những dữ liệu đã
                      được xử lý trước đó;
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "20px" }}>h)</div>
                    <div style={{ paddingLeft: "20px" }}>
                      Khách hàng có thể chọn khiếu nại và yêu cầu bồi thường
                      thiệt hại (nếu có) theo quy định của pháp luật khi có căn
                      cứ cho rằng dữ liệu cá nhân của mình bị xâm phạm, bị xử lý
                      sai mục đích, không đúng thỏa thuận;
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "20px" }}>i)</div>
                    <div style={{ paddingLeft: "20px" }}>
                      Khách hàng có thể thông báo về lựa chọn hoặc yêu cầu đối
                      với vấn đề nào xử lý dữ liệu được liệt kê ở trên bằng các
                      kênh được nêu trong phần “9. Liên hệ với chúng tôi” của
                      văn bản này
                    </div>
                  </div>
                  <div>
                    <b>9. Liên hệ với chúng tôi</b>
                  </div>
                  <div>
                    Nếu Khách hàng có bất kỳ câu hỏi nào về chính sách bảo vệ Dữ
                    liệu cá nhân của Khách hàng của Bệnh viện, hoặc nếu Khách
                    hàng muốn thực hiện bất kỳ quyền nào của mình, hoặc có bất
                    kỳ khiếu nại nào muốn thảo luận với chúng tôi, trước tiên
                    hãy gửi cho chúng tôi yêu cầu có chữ ký và có ghi ngày
                    tháng, cùng với một bản sao chứng minh nhân dân/căn cước
                    công dân/hộ chiếu hợp lệ và còn thời hạn của Khách hàng. Vui
                    lòng gửi yêu cầu chính xác nhất đến:
                  </div>
                  <div>bằng bưu điện gửi đến</div>
                  <div>
                    <b>
                      [MMS-010, MMS-011, MMS-012, Khu biệt thự Mimosa, KĐT
                      Ecopark, xã Xuân Quan, huyện Văn Giang, Hưng Yên ]
                    </b>
                  </div>
                  <div>hoặc</div>
                  <div>
                    bằng thư điện tử gửi đến <b>[cskh@alinavision.com ]</b>
                  </div>
                  <div>
                    <b>
                      Bằng việc ký văn bản này, Khách hàng xác nhận rằng đã
                      được:
                    </b>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "20px" }}>a)</div>
                    <div style={{ paddingLeft: "20px" }}>
                      {" "}
                      Thông báo, giải thích rõ các nội dung của việc xử lý Dữ
                      liệu cá nhân của Khách hàng; và
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "20px" }}>b)</div>
                    <div style={{ paddingLeft: "20px" }}>
                      Đồng ý để Bệnh viện xử lý Dữ liệu cá nhân của Khách hàng
                      theo các nội dung giải thích nêu trên.
                    </div>
                  </div>
                </Card>
              </Row>
              {/* <Table
                className="signSecure-table"
                style={{width: "100%", margin: "10px 0"}}
                bordered
                columns={column}
                dataSource={dataTable}
                pagination={false}
              ></Table> */}
              <div className="table-sign-custom">
                <table>
                  <thead>
                    <tr>
                      <th style={{ width: "150px" }}></th>
                      <th>
                        <Typography.Text strong>Họ và tên</Typography.Text>
                      </th>
                      <th>
                        <Typography.Text strong>Chữ kí/vân tay</Typography.Text>
                      </th>
                      <th>
                        <Typography.Text strong>Ngày</Typography.Text>
                      </th>
                      <th>
                        <Typography.Text strong>Giờ</Typography.Text>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr style={{ height: "120px" }}>
                      <td style={{ textAlign: "center" }}>
                        <Typography.Text>
                          Bệnh nhân/người giám hộ
                        </Typography.Text>
                      </td>
                      <td style={{ width: "200px" }}>
                        <div>
                          <SignatureCanvas
                            ref={hoTenCanvas}
                            canvasProps={{
                              width: "200px",
                              height: "120px",
                              className: "hoTenCanvas",
                            }}
                          />
                        </div>
                      </td>
                      <td style={{ width: "200px" }}>
                        <div>
                          <SignatureCanvas
                            ref={sigCanvas}
                            canvasProps={{
                              width: "200px",
                              height: "120px",
                              className: "sigCanvas",
                            }}
                          />
                        </div>
                      </td>
                      <td style={{ textAlign: "center" }}>
                        <Typography.Text>
                          {thongTinBN?.ngayNhapVien
                            ? dayjs(thongTinBN?.ngayNhapVien).format(
                                FORMAT_TIME.dayFull
                              )
                            : ""}
                        </Typography.Text>
                      </td>
                      <td style={{ textAlign: "center" }}>
                        <Typography.Text>
                          {thongTinBN?.ngayNhapVien
                            ? dayjs(thongTinBN?.ngayNhapVien).format(
                                FORMAT_TIME.time_24h
                              )
                            : ""}
                        </Typography.Text>
                      </td>
                    </tr>
                    <tr style={{ height: "120px" }}>
                      <td style={{ textAlign: "center" }}>
                        <Typography.Text>Đại diện bệnh viện</Typography.Text>
                      </td>
                      <td style={{ width: "200px" }}>
                        <div>
                          <SignatureCanvas
                            ref={bvCanvas}
                            canvasProps={{
                              width: "200px",
                              height: "120px",
                              className: "bvCanvas",
                            }}
                          />
                        </div>
                      </td>
                      <td style={{ width: "200px" }}>
                        <div>
                          <SignatureCanvas
                            ref={sigBvCanvas}
                            canvasProps={{
                              width: "200px",
                              height: "120px",
                              className: "sigBvCanvas",
                            }}
                          />
                        </div>
                      </td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <Row>
                <Row justify={"end"}>
                  <Typography.Text
                    className="date-sign"
                    style={{ marginRight: "15px" }}
                  >
                    {getTodayString()}
                  </Typography.Text>
                </Row>
                <Row justify={"space-between"}>
                  <Col>
                    <Space direction="vertical" size={64}>
                      <Row>
                        <Row justify={"center"}>
                          <Typography.Text strong>
                            Bệnh nhân/Thân nhân
                          </Typography.Text>
                        </Row>
                        <Row justify={"center"}>
                          <Typography.Text type="secondary">
                            (Ký và ghi rõ họ tên)
                          </Typography.Text>
                        </Row>
                      </Row>
                      <Row justify={"center"}>
                        <Typography.Text strong>
                          {thongTinBN?.hoTen}
                        </Typography.Text>
                      </Row>
                    </Space>
                  </Col>
                  <Col>
                    <Space direction="vertical" size={64}>
                      <Row>
                        <Row justify={"center"}>
                          <Typography.Text strong>
                            Người tiếp nhận
                          </Typography.Text>
                        </Row>
                        <Row justify={"center"}>
                          <Typography.Text type="secondary">
                            (Ký và ghi rõ họ tên)
                          </Typography.Text>
                        </Row>
                      </Row>
                      <Row justify={"center"}>
                        <Typography.Text strong>
                          {thongTinBN?.nhanVienTiepNhan}
                        </Typography.Text>
                      </Row>
                    </Space>
                  </Col>
                </Row>
              </Row>
            </Row>
          </Row>
          {/* <Row justify={"start"}>
            <Col>
              <Space>
                <Button type="ghost" className="btn-sub" onClick={onClearSign}>
                  Xoá chữ kí
                </Button>
                <Button type="primary" onClick={onSaveSign}>
                  Lưu chữ kí
                </Button>
              </Space>
            </Col>
          </Row> */}
          <Row justify={"space-between"} style={{ marginTop: "8px" }}>
            <Col xs={24} sm={24} md={24} lg={16} xl={16}>
              <Row justify={"start"}>
                <ReactToPrint
                  trigger={() => {
                    return (
                      <Button
                        icon={<Icons.printer rev={0} />}
                        onClick={onPrint}
                      >
                        In biên bản mới
                      </Button>
                    );
                  }}
                  content={() => NewPrintRef.current}
                  bodyClass="print-sign"
                  pageStyle="@page { padding: 30px 0 }"
                />
                <ReactToPrint
                  trigger={() => {
                    return (
                      <Button
                        onClick={onPrint}
                        icon={<Icons.printer rev={0} />}
                      >
                        In biên bản đã ký
                      </Button>
                    );
                  }}
                  content={() => printRef.current}
                  bodyClass="print-sign"
                  pageStyle="@page { padding: 30px 0 }"
                />
                {/* <Upload
                  customRequest={customRequest}
                  accept=".pdf"
                  multiple
                  showUploadList={false}
                >
                  <Button
                    type="default"
                    icon={<Icons.upload rev={0} />}
                    onClick={handleOnUpload}
                  >
                    Upload biên bản
                  </Button>
                </Upload> */}
                <Button
                  type="default"
                  icon={<Icons.eye rev={0} />}
                  onClick={handleOnView}
                >
                  Xem biên bản đã kí
                </Button>
              </Row>
            </Col>
            {/* <Col xs={24} sm={24} md={24} lg={8} xl={8}>
              <Row justify={"end"} style={{gap: "4px"}}>
                <Button danger onClick={closeModal}>
                  HỦY
                </Button>
                <Button type="primary" onClick={closeModal}>
                  Lưu
                </Button>
              </Row>
            </Col> */}
          </Row>
        </div>
      </Modal>
      <SignPdfView modalViewer={modalViewer} filePdf={filePdf} />
      <NewSignSecure ref={NewPrintRef} thongTinBN={thongTinBN}></NewSignSecure>
    </Row>
  );
};
export default SignSecure;
